
angular.module('bmsApp.crm.customer').controller('CustomerViewSitesCtrl', [
	'$scope',
	'$ngBootbox',
	'ngTableParams',
	'SiteSvc', function (
		$scope,
		$ngBootbox,
		ngTableParams,
		SiteSvc) {

		$scope.tabs.sites.select = function () {
			if (angular.isUndefined($scope.additionalSites)) {
				$scope.tabs.sites.loadAdditional();
			}
		};

		$scope.tabs.sites.loadAdditional = function () {
			if (angular.isUndefined($scope.additionalSites)) {
				$scope.additionalSites = new ngTableParams(angular.extend({
					page: 1, // show first page
					count: $scope.config.tabbedTable.params.count, // count per page
					sorting: {
						display_name: 'asc' // initial sorting
					}
				}), {
					total: 0, // length of data
					counts: $scope.config.tabbedTable.settings.counts, // available page counts
					getData: function ($defer, params) {
						SiteSvc.byCustomer($scope.customerId, false, params.$params)
							.then(function (response) {
								$scope.siteTotal = response.data.site_total_count;
								params.total(response.data.site_filtered_count);
								$defer.resolve(response.data.site_collection);
							});
					}
				});
			}
			else {
				$scope.additionalSites.reload();
			}
		};

		$scope.tabs.sites.showForm = function (site) {
			site.customer = {
				id: $scope.customerId
			};
			SiteSvc.showSaveModal(site)
				.then(function () {
					$scope.setActiveTab('sites');
					$scope.tabs.sites.loadAdditional();
				});
		};

		$scope.tabs.sites.confirmPrimary = function (site) {
			$ngBootbox.confirm('Are you sure you want to do this?')
				.then(function () {
					SiteSvc.setPrimary(site)
						.then(function () {
							$scope.loadCustomer();
							$scope.tabs.sites.loadAdditional();
						});
				});
		};

	}]);